import { createActionGroup, props } from '@ngrx/store';
import { CategoryRestrictionsProfileConfiguration } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';
import { Category } from '../router/category';

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfilePresetConfigurationApiActions = createActionGroup({
  source: 'Restriction Profile Preset Configuration API',
  events: {
    'Restriction Profile Configuration set failed': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryRestrictionProfilePresetConfigurationViewActions = createActionGroup({
  source: 'Restriction Profile Preset Configuration Category view',
  events: {
    'Restriction Profile Configuration selected': props<{
      category: Category;
      profiles: CategoryRestrictionsProfileConfiguration[];
    }>(),
  },
});
